import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import photogalleriesJSON from '../Data/newphotogallery.json';

class HomePhotogalleryTile extends Component {
  render() {
    const gallery = photogalleriesJSON.items[0];
    if (!gallery) return null;

    const imageUrl = `/Images/fotky/${gallery.FolderName}/small/${gallery.MainPhotoName.replace('.JPG', '.jpg')}`;
    const link = `/fotogalerie/${gallery.Url}`;

    return (
      <div className="hp-tile">
        <h2 className="hp-tile-heading">Nejnovější fotogalerie</h2>
        <Link to={link}>
          <div className="hp-tile-gallery-image">
            <div
              className="photogallery-main-image-inner"
              style={{ backgroundImage: `url(${imageUrl})` }}
            />
            <span className="hp-tile-gallery-title">{gallery.AlbumName}</span>
          </div>
        </Link>
        <div className="hp-tile-footer">
          <Link to="/fotogalerie">Všechny fotogalerie →</Link>
        </div>
      </div>
    );
  }
}

export default HomePhotogalleryTile;
